import {Card} from "../../../../../../../../components/card/card.jsx";
import CpfRiskLevel from "./cpf-risk-level.jsx";
import DashCard from "../../../../../../../../components/dash-card/dash-card.jsx";
import ProtectiveOverview from "./protective-overview.jsx";
import AggressorsTypesOverview from "./aggressors-types-overview.jsx";

export default function CpfCard({ data }) {
    return (
        <div className="dash-main-card-toggle col-span-9 row-span-1">
            <Card className="dash-main-card h-full">
                <Card.Header className="border-b-0! bg-transparent!">
                    <Card.Title className="bg-transparent text-[#F4FFFF] text-center translate-y-1.5 w-full text-(length:--font-lg)!">
                        CPFs cadastrados
                    </Card.Title>
                </Card.Header>
                <Card.Body className="flex-1 min-h-0 flex px-(--dash-pad-md)! pb-(--dash-pad-md)!">
                    <DashCard width="100%" height="100%" className="h-full min-h-0">
                        <section className="h-full min-h-0 min-w-0 grid grid-cols-[1.05fr_1fr_1.1fr] gap-(--dash-pad-md)">
                            <CpfRiskLevel data={data} />
                            <ProtectiveOverview data={data} />
                            <AggressorsTypesOverview data={data} />
                        </section>
                    </DashCard>
                </Card.Body>
            </Card>
        </div>
    )
}
